import React from "react";
import Table from "@mui/joy/Table";
import { styled } from "@mui/system";
import { Trans, useTranslation } from "react-i18next";
const ProductTable = () => {
  const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
  };

  const blue = {
    200: "#99CCFF",
    300: "#66B2FF",
    400: "#3399FF",
    500: "#007FFF",
    600: "#0072E5",
    700: "#0066CC",
  };
  const PopupBody = styled("div")(
    ({ theme }) => `
        width: max-content;
        padding: 12px 16px;
        margin: 8px;
        border-radius: 8px;
        border: 1px solid ${
          theme.palette.mode === "dark" ? grey[700] : grey[200]
        };
        background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
        box-shadow: ${
          theme.palette.mode === "dark"
            ? `0px 4px 8px rgb(0 0 0 / 0.7)`
            : `0px 4px 8px rgb(0 0 0 / 0.1)`
        };
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 0.875rem;
        z-index: 1;
      `
  );

  return (
    <Table
      aria-label="basic"
      sx={{
        width: "auto",
        margin: " auto ",
        "& tr > *:not(:first-child)": { textAlign: "right" },
        
      }}
    >
      <PopupBody>
        <thead>
          <tr>
            <th style={{ width: "70%" }}>
              <Trans i18nKey="global:popup_device" />
            </th>
            <th style={{ width: "30%" }}>
              <Trans i18nKey="global:popup_token" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Z_Fold6" />
            </td>
            <td>9</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Z_Flip6" />
            </td>
            <td>6</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_S24" />
            </td>
            <td>6</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_S24FE" />
            </td>
            <td>6</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_A_Series" />
            </td>
            <td>3</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Watch" />
            </td>
            <td>3</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Ring" />
            </td>
            <td>3</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_NPC" />
            </td>
            <td>9</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Tablet_S_Series" />
            </td>
            <td>6</td>
          </tr>
          <tr>
            <td>
              <Trans i18nKey="global:galaxy_Tablet_A_FE_Series" />
            </td>
            <td>3</td>
          </tr>
        </tbody>
      </PopupBody>
    </Table>
  );
};

export default ProductTable;
